export default __webpack_public_path__ + "static/media/22_tag_washing-machine.cbdad63f.svg";